<template>
  <div class='container'>
    <div
      class="video-float"
      @click="play"
      :class="videoBtnShow ? 'show' + btnstyle : 'hidden'"
    >
      <div :class="['play-btn' , 'play-btn' + btnstyle]"></div>
      <div class="video-text">{{btnName}}</div>
    </div>
    <CourseVideo :src="src" :flag="flag" @close="close" specialStyle="1"></CourseVideo>
  </div>
</template>
            
<script>
import CourseVideo from "./courseVideo.vue";
export default {
  components: {
    CourseVideo,
  },
  props:["src","btnName","btnstyle"],
  data() {
    return {
      flag: false,
      targetSrc: "",
      videoBtnShow: false,    
    }
  },
  mounted() {
      this.videoBtnShow = true
    },
  methods:{
    play() {
      this.targetSrc =this.src;
      this.flag = true;
    },
    close() {
      this.targetSrc = "";
      this.flag = false;
    },
  },
}
</script>
        
<style lang="scss" scoped>
.show {
  width: 222px !important;
  .video-text {
    width: 100% !important;
  }
}
.show3{
  width: 238px !important;
  .video-text {
    width: 100% !important;
  }
}
.video-float {
  transition: all 0.5s;
  position: fixed;
  right: 0;
  top: 136px;
  width: 10px;
  height: 64px;
  background: #ffffff
    linear-gradient(
      142deg,
      rgba(214, 222, 255, 0.5) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
  box-shadow: 0px 4px 24px -8px rgba(94, 123, 218, 0.4);
  border-radius: 200px 0px 0px 200px;
  cursor: pointer;
  display: flex;
  align-items: center;
  z-index: 29;

  .play-btn {
    width: 36px;
    height: 36px;
    display: inline-block;
    flex-shrink: 0;
    margin: 0px 12px 0px 16px;
  }

  .play-btn3{
     background: url("../../../assets/coursePage/web/webPlay.png");
     background-size: cover;
  }

  .video-text {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #273f6e;
    white-space: nowrap;

    width: 0;
    overflow: hidden;
  }
}
</style>